import { IOtherResult } from '@betrail-libs/shared/interfaces/interfaces';
export class EditOtherResultDialogData {
  otherResult: IOtherResult;
}
